import { Injectable } from '@angular/core';
import { AppAvailability } from '@ionic-native/app-availability';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { ToastController, LoadingController, AlertController, Platform } from 'ionic-angular';
import { ENV } from '@app/env';

/*
*
*  Utils Provider
*
*/
@Injectable()
export class Utils {

    private loading  : any;
    public isLoading : boolean = false;
    public hasMessage : boolean = false;
    public logs : any = [];

    constructor(
        public platform:Platform,
        private appAvailability: AppAvailability,
        private inAppBrowser: InAppBrowser,
        public toastCtrl: ToastController,
        public loadingCtrl: LoadingController,
        public alertCtrl: AlertController
    ) {
    }

    /*
    *  Loading
    */
    load(message:string = '', cssClass:string = '') {
        if(!this.loading) {
            this.loading = this.loadingCtrl.create({
                content: message,
                dismissOnPageChange:false,
                spinner:'ios',
                cssClass:(message ? 'load_message' : cssClass)
            });
    
            this.isLoading = true;
            this.loading.present();
        }
    }

    /*
    *    Change in Progress Loading content
    */
    setLoaderContent(text) {
        if (this.loading) {
            this.loading.setContent(text);
        }
    }

    /*
    *  Dismiss loading
    */
    unload() {
        if (this.loading != null) {
            this.loading.dismiss();
            this.isLoading = false;
            this.loading = null;
        }
    }

    /*
    *  Toast error message
    */
    error(message, params?: any) {

        if (this.hasMessage) return false;

        this.hasMessage = true;

        let toast = this.toastCtrl.create({
            message: message,
            duration: 3000,
            cssClass:'toast-error',
            position:'top'
        });

        toast.onDidDismiss(() => {
            this.hasMessage = false;
        });
        
        toast.present();
    }

    /*
    *  Toast success message
    */
    success(message, params?:any) {

        if (this.hasMessage) return false;

        this.hasMessage = true;

        let toast = this.toastCtrl.create({
            message: message,
            duration: 3000,
            cssClass:'toast-success',
            position:'top'
        });

        toast.onDidDismiss(() => {
            this.hasMessage = false;
        });

        toast.present();
    }

    /*
    *  Toast success message
    */
    info(message, params?:any) {

        if (this.hasMessage) return false;

        this.hasMessage = true;

        let toast = this.toastCtrl.create({
            message: message,
            duration: 3000,
            cssClass:'toast-info',
            position:'top'
        });

        toast.onDidDismiss(() => {
            this.hasMessage = false;
        });

        toast.present();
    }

    /*
    *    Confirm Alert
    */ 
    confirm(params, callback, callback2?:any) {
        let alert = this.alertCtrl.create({
          title: params.title,
          message: params.message,
          buttons: [
            {
              text: 'Cancel',
              role: 'cancel',
              handler: () => {
                  if (callback2) callback2();
              }
            },
            {
              text: 'Yes',
              handler: () => {
                callback();
              }
            }
          ]
        });
        alert.present();
    }

    // Check External Application Availability 
    checkApplication(_application) {

        return new Promise((resolve, reject) => {

            let app: string;

            if (this.isBrowser()) {
                resolve();
            } else if (this.isAndroid()) {
                app = _application.package_name;
            } else {
                app = _application.uri_scheme;
            }
            
            if (app) {
                this.appAvailability.check(app).then(
                    () => {
                        resolve();
                    },
                    () => {
                        reject();
                    }
                );
            } else {
                reject();
            }
        });
    }

    // Launch external Application
    launchExternalApp(_application) {
        this.checkApplication(_application).then((response) => {
            this.log('Utils::launchExternalApp::'+_application.url);
            if (this.isBrowser()) {
                this.inAppBrowser.create(_application.website_url, '_system');
            } else {
                if (this.isAndroid()) {
                    this.inAppBrowser.create(_application.url, '_system');
                } else {
                    this.inAppBrowser.create(_application.uri_scheme, '_system');
                }
            }
            
        }, (err) => {});
    }

    /*
    *    Log function
    */
    log(message, type?:string) {

        this.logs.push({'type' : type, 'message' : message,'time': new Date().toLocaleTimeString()});
        
        if (!type) {
            console.log(message);
        } else if (type == 'log') {
            console.log(message);
        } else if (type == 'warn') {
            console.warn(message);
        } else if (type == 'error') {
            console.error(message);
        } 
    }

    /*
    *    Truncate text
    */
    truncate(str, length, ending) {
        if (length == null) {
            length = 100;
        }
        if (ending == null) {
            ending = '...';
        }
        if (str.length > length) {
            return str.substring(0, length - ending.length) + ending;
        } else {
            return str;
        }
    }

    /*
    *    Check if is object
    */
    isObject(obj) {
        return obj === Object(obj);
    }

    /*
    *    Check if is mobile
    */
    isIOS()
    {
        return this.platform.is('ios');
    }

    /*
    *    Check if is mobile
    */
    isAndroid()
    {
        return this.platform.is('android');
    }

    /*
    *    Check if is mobile
    */
    isMobile()
    {
        return this.platform.is('cordova');
    }

    /*
    *    Check if is browser
    */
    isBrowser()
    {
        return ENV.isBrowser;
    }

    // Get Random Int
    getRandomInt() { return Math.floor(Math.random() * Math.floor(999999)); }
}


// WEBPACK FOOTER //
// ./src/providers/utils/utils.ts